import makeStyles from '@mui/styles/makeStyles';

export default makeStyles((theme) => ({
    label: {
        fontSize: theme.typography.pxToRem(18),
        marginTop: theme.typography.pxToRem(22),
        marginBottom: theme.typography.pxToRem(8)
    }
}));
